import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/finances/')({
	beforeLoad: () => {
		throw redirect({ to: '/finances/invoices' })
	},
})
